module.exports = __webpack_public_path__ + "img/support-banner-m.2d68a06e.jpg";